import { useNavigate } from 'react-router-dom'

import { ActionItem } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { leaveEmployee } from 'modules/timeoff/lib/leaveEmployees'
import type Leave from 'modules/timeoff/store/models/Leave'
import MedicalLeaveUpdate from 'modules/timeoff/store/models/MedicalLeaveUpdate'

import * as styles from './index.vanilla.css'

interface Props {
  update?: MedicalLeaveUpdate
  leave: Leave
}

const computeName = (isStart: boolean, update?: MedicalLeaveUpdate) => {
  if (isStart) {
    return i18n.t('time_off.medical_leave.updates.types.medical_leave_start')
  }

  return update ? update.name : '-'
}

const computeDate = (leave: Leave, update?: MedicalLeaveUpdate) => {
  if (!update) return moment(leave.attributes.start_on).format('L')

  const startDate = moment(update.attributes.effective_on).format('L')

  if (update.attributes.leave_update_type !== MedicalLeaveUpdate.types.medical_hospital_stay) {
    return startDate
  }

  const endDate = moment(update.attributes.hospital_finish_on).format('L')

  return i18n.t('time_off.medical_leave.updates.date_range', {
    start_date: startDate,
    end_date: endDate,
  })
}

const UpdateItem = ({ update, leave }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { employee: currentEmployee } = useCurrentSession()

  const isStart = !update
  const name = computeName(isStart, update)
  const date = computeDate(leave, update)

  const buildRoute = (path: 'editMedicalLeave' | 'edit'): string => {
    const employee = leaveEmployee(leave)
    const updateId = update ? update.attributes.id : null

    const anotherRoute =
      path === 'edit'
        ? navigation.employees.id.timeOff.leaveUpdatesLeaveIdEditLeaveUpdateId.fullPath({
            id: employee.attributes.id,
            leave_id: leave.attributes.id,
            leave_update_id: updateId,
          })
        : navigation.employees.id.timeOff.leaveUpdatesLeaveIdEditMedicalLeave.fullPath({
            id: employee.attributes.id,
            leave_id: leave.attributes.id,
          })

    const myRoute =
      path === 'edit'
        ? navigation.timeOff.leaveUpdatesLeaveIdEditLeaveUpdateId.fullPath({
            leave_id: leave.attributes.id,
            leave_update_id: updateId,
          })
        : navigation.timeOff.leaveUpdatesLeaveIdEditMedicalLeave.fullPath({
            leave_id: leave.attributes.id,
          })

    return currentEmployee?.id === employee.id ? myRoute : anotherRoute
  }

  const onClickEdit = () => {
    const path = isStart ? 'editMedicalLeave' : 'edit'
    navigate(buildRoute(path))
  }

  return (
    <ActionItem onClick={() => onClickEdit()}>
      <div className={styles.item}>
        <div className={styles.content}>
          <div className={styles.title}>{name}</div>
          <div className={styles.info}>
            <div className={styles.date}>{date}</div>
          </div>
        </div>
      </div>
    </ActionItem>
  )
}

export default UpdateItem
